import { fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { config } from '../../services/config';
import { buildLoginUrlWithRedirect } from '../../services/authRedirect';
import { notification } from 'antd';

const baseQuery = fetchBaseQuery({
  baseUrl: config.BASE_URL,
  credentials: 'include',
});

// Custom wrapper around baseQuery
export const baseQueryWithAuthRedirect: typeof baseQuery = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  const status = (result.error as FetchBaseQueryError | undefined)?.status;
  const detail = (result.error as any)?.data?.detail || (result.error as any)?.error || undefined;

  if (status === 401 || status === 403) {
    // Show backend-provided message (if any) so user sees reason like "Invalid token or user is not logged in"
    try {
      notification.error({
        message: 'Authentication',
        description: detail || 'Session expired. Please log in again.',
      });
    } catch (e) {
      // ignore notification failures
    }

    // Try to call backend session logout to ensure server-side session/cookie cleared
    try {
      await fetch(`${config.BASE_URL}/session_logout/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (e) {
      // ignore network errors
    }

    // Mark session as inactive locally (don't clear other localStorage keys)
    try {
      localStorage.setItem('isAuthenticated', JSON.stringify(false));
    } catch (e) {
      // ignore
    }

    // Redirect to login page, preserving current path and query so user returns here after login
    const loginUrl = buildLoginUrlWithRedirect(window.location.pathname, window.location.search);
    window.location.href = loginUrl;
  }

  return result;
};
